import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
//import styled from 'styled-components'
import { graphql } from "gatsby"
//STYLES
import { ProductWrapper } from "../utils/utils"
import { Text, H2 } from "../utils/typo"
//COMPONENTS
import SEO from "../components/seo/SEO"
import Layout from "../layout/layout2"
import Button from "../components/button/Button"
import Baner from "../components/baner/Baner"

const Produkty = ({ pageContext, data }) => {
  let { page } = data
  const subPage = data.allDatoCmsPodstronyProduktowe.edges

  return (
    <div>
      <SEO title="Home" slug="/page3" />
      <Layout lang={pageContext.locale} slug={pageContext.slug}>
        <Baner
          image={page.baner.gatsbyImageData}
          alt="Baner - grupa kapitałowa"
          height="2rem"
          heading={page.heading}
          align="right"
        />

        {subPage.map(({ node }) => {
          return (
            <ProductWrapper
              key={node.id}
              variant={node.position % 2 === 1 ? "left" : "right"}
            >
              <div>
                <span>
                  <H2>{node.heading}</H2>
                  <Text dangerouslySetInnerHTML={{ __html: node.intro }} />
                  {node.podstrona === true ? (
                    <Button
                      to={
                        pageContext.locale === "pl-PL"
                          ? `/${node.slug}`
                          : `/en/${node.slug}`
                      }
                    >
                      {pageContext.locale === "en"
                        ? "More info"
                        : "Więcej informacji"}
                    </Button>
                  ) : !node.doPobrania || node.doPobrania.length === 0 ? (
                    <></>
                  ) : (
                    <Button href={node.doPobrania[0].url} target="blank">
                      {pageContext.locale === "en"
                        ? "More info"
                        : "Więcej informacji"}
                    </Button>
                  )}
                </span>
                <span>
                  <GatsbyImage
                    image={node.mainImage.gatsbyImageData}
                    alt={node.heading}
                    objectFit="contain"
                  />
                </span>
              </div>
            </ProductWrapper>
          )
        })}
      </Layout>
    </div>
  )
}
export default Produkty

export const query = graphql`
  query ProduktyQuery($locale: String!) {
    page: datoCmsProduktyPage(locale: { eq: $locale }) {
      locale
      slug
      heading
      baner {
        gatsbyImageData
      }
    }

    allDatoCmsPodstronyProduktowe(
      sort: { fields: position }
      filter: { locale: { eq: $locale } }
    ) {
      edges {
        node {
          heading
          intro
          slug
          position
          id
          podstrona
          doPobrania {
            url
            title
            format
          }
          mainImage {
            gatsbyImageData
          }
        }
      }
    }
  }
`
